import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  BookIcon,
  UsersIcon,
  ActivityIcon,
  GiftIcon,
  ShoppingBagIcon,
  HomeIcon,
  MessageCircleIcon,
  VideoIcon,
} from '../Icons';
import { SettingsIcon } from 'lucide-react';
import { LibraryBig } from 'lucide-react';
import { Megaphone } from 'lucide-react';

type SidebarLinkProps = {
  to: string;
  label: string;
  icon: string;
  onClick?: () => void;
};

const SidebarLink: React.FC<SidebarLinkProps> = ({ to, label, icon, onClick }) => {
  const location = useLocation();

  const isActive = () => {
    if (to === '/aluna' && location.pathname === '/aluna') return true;
    if (to !== '/aluna' && location.pathname.startsWith(to)) return true;
    return false;
  };

  const active = isActive();

  const renderIcon = () => {
    const className = active ? 'text-white' : 'text-gray-700';

    switch (icon) {
      case 'home': return <HomeIcon className={className} size={16} />;
      case 'mycourses': return <LibraryBig className={className} size={16} />;
      case 'book': return <BookIcon className={className} size={16} />;
      case 'video': return <VideoIcon className={className} size={16} />;
      case 'users': return <UsersIcon className={className} size={16} />;
      case 'message-circle': return <MessageCircleIcon className={className} size={16} />;
      case 'activity': return <ActivityIcon className={className} size={16} />;
      case 'gift': return <GiftIcon className={className} size={16} />;
      case 'shopping-bag': return <ShoppingBagIcon className={className} size={16} />;
      case 'settings': return <SettingsIcon className={className} size={16} />;
      case 'megaphone': return <Megaphone className={className} size={16} />;
      default: return null;
    }
  };

  return (
    <li>
      <Link
        to={to}
        onClick={onClick}
        className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
          active ? 'bg-terracota text-white' : 'text-gray-700 hover:bg-gray-100'
        }`}
      >
        {renderIcon()}
        <span className="text-sm font-medium">{label}</span>
      </Link>
    </li>
  );
};

export default SidebarLink;
